
import { defineComponent } from 'vue';
import T from '../../lang';

export default defineComponent({
  name: 'LogoutConfirmation',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  data() {
    return {
      T,
    };
  },
  computed: {
    showModal: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean): void {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    confirmLogout(): void {
      window.location.href = '/logout/';
    },
  },
});
